import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "box-empty"
}
const _hoisted_3 = { class: "signatures" }
const _hoisted_4 = {
  key: 0,
  class: "item"
}
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "documents" }
const _hoisted_7 = { class: "flex flex-col gap-2" }
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col gap-2"
}
const _hoisted_9 = { class: "sign" }
const _hoisted_10 = { class: "actions" }

import { concat, debounce } from "lodash-es";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

import { bsonId } from "@/common/utils/common";
import { maskCPF, maskCNPJ } from "@/common/utils/mask";
import { toast } from "@/common/utils/toast";

import {
  analysisSignatureList,
  analysisSignatureCreate,
  analysisSignaturePatch,
  analysisSignatureDelete,
} from "@/common/api/rest/analysis/signature";

import {
  baseConfirm,
  baseInput,
  baseSelect,
  baseSignature,
  baseTextarea,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'signature',
  props: {
    data: {},
    accountId: {},
    analysisId: {},
    width: { default: "100%" },
    isEdit: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_PAYLOAD = {
  type: "",
  type_name: null,
  name: "",
  document_type: "",
  document_name: "",
  document_number: "",
  signature: "",
  description: "",
};

const signatures = ref<any[]>([]);
const selected = ref<any | null>(null);

const showConfirmDel = ref(false);

const signatureOptions = computed(() => [
  {
    option: t("common.labels.administrator"),
    value: "ADMINISTRATOR",
  },
  {
    option: t("common.labels.assistant"),
    value: "ASSISTANT",
  },
  {
    option: t("common.labels.employee"),
    value: "EMPLOYEE",
  },
  {
    option: t("common.labels.manager"),
    value: "MANAGER",
  },
  {
    option: t("common.labels.technical"),
    value: "TECHNICAL",
  },
  {
    option: t("common.labels.other"),
    value: "OTHER",
  },
]);

const documentOptions = computed(() => [
  {
    option: t("common.labels.cpf"),
    value: "CPF",
  },
  {
    option: t("common.labels.cnpj"),
    value: "CNPJ",
  },
  {
    option: t("common.labels.other"),
    value: "OTHER",
  },
]);

function fecthSignatures() {
  analysisSignatureList(props.accountId, {
    analysis_id: props.analysisId,
    page: 0,
    limit: 100,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        signatures.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function addSignature() {
  const { name, social_name } = props.data?.technical ?? {};

  analysisSignatureCreate(props.accountId, {
    ...DEFAULT_PAYLOAD,
    evaluation_id: props.data.evaluation_id,
    analysis_id: props.data.analysis_id,
    type: "TECHNICAL",
    name: social_name || name,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });
        emit("update-data");
        fecthSignatures();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function patch(index: number, payload: any) {
  const signature = signatures.value[index];

  analysisSignaturePatch(props.accountId, signature.signature_id, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });
        emit("update-data");
        fecthSignatures();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function update(index: number, key: string) {
  const signature = signatures.value[index];
  analysisSignaturePatch(props.accountId, signature.signature_id, {
    [key]: signature[key],
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });
        emit("update-data");
        fecthSignatures();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function saveSignature(index: number, signature: string) {
  signatures.value[index].signature = signature;

  update(index, "signature");
}

function documentMask(index: number, value: any) {
  if (signatures.value[index].document_type === "CPF") return maskCPF(value);

  if (signatures.value[index].document_type === "CNPJ") return maskCNPJ(value);

  return value;
}

function changeType(index: number, type: string) {
  let payload: any = {
    type,
  };

  switch (type) {
    case "ASSISTANT":
      if (props.data?.assistant) {
        const { name, social_name } = props.data.assistant;

        payload = {
          ...DEFAULT_PAYLOAD,
          signature: payload.signature,
          name: social_name || name,
          document_type: "OTHER",
          document_name: null,
          document_number: null,
          type,
          type_name: null,
        };
      }
      break;

    case "TECHNICAL":
      if (props.data?.technical) {
        const { name, social_name } = props.data.technical;

        payload = {
          ...DEFAULT_PAYLOAD,
          signature: payload.signature,
          name: social_name || name,
          document_type: "OTHER",
          document_name: null,
          document_number: null,
          type,
          type_name: null,
        };
      }
      break;

    case "EMPLOYEE":
      if (props.data?.employee) {
        const {
          name,
          social_name,
          document_type,
          document_name,
          document_number,
        } = props.data.employee;

        payload = {
          ...DEFAULT_PAYLOAD,
          signature: payload.signature,
          name: social_name || name,
          document_type,
          document_name,
          document_number,
          type,
          type_name: null,
        };
      }

      break;

    default:
      payload = {
        ...DEFAULT_PAYLOAD,
        signature: payload.signature,
        document_type: "OTHER",
        document_name: null,
        document_number: null,
        type: payload.type,
        type_name: null,
      };
      break;
  }

  patch(index, payload);
}

function changeDocumentType(index: number, type: string | null) {
  signatures.value[index].document_name = type;
  signatures.value[index].document_number = documentMask(
    index,
    signatures.value[index].document_number,
  );

  if (type === "OTHER") {
    signatures.value[index].document_name = "";
  }

  patch(index, {
    document_name: signatures.value[index].document_name,
    document_number: signatures.value[index].document_number,
    document_type: signatures.value[index].document_type,
  });
}

function del(signature: any) {
  selected.value = signature;
  showConfirmDel.value = true;
}

function delCancel() {
  showConfirmDel.value = false;
  selected.value = null;
}

function delConfirm() {
  if (!selected.value) return;

  analysisSignatureDelete(props.accountId, selected.value.signature_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        delCancel();
        emit("update-data");
        fecthSignatures();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

onMounted(() => {
  fecthSignatures();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", {
      class: _normalizeClass(["tab-component", { width: __props.width }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (signatures.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(_unref(t)("analysis.texts.empty_signature")) + " ", 1),
              _createElementVNode("button", {
                class: "btn btn-md btn-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (addSignature()))
              }, _toDisplayString(_unref(t)("common.labels.add", {
                concat: _unref(t)("common.labels.signature"),
              }).toUpperCase()), 1)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(signatures.value, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
                    item
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_unref(baseSelect), {
                              modelValue: item.type,
                              "onUpdate:modelValue": ($event: any) => ((item.type) = $event),
                              value: item.type,
                              options: signatureOptions.value,
                              "is-empty": false,
                              required: "",
                              onChange: ($event: any) => (changeType(index, $event))
                            }, {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)("common.labels.type")) + " * ", 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onUpdate:modelValue", "value", "options", "onChange"]),
                            (item.type === 'OTHER')
                              ? (_openBlock(), _createBlock(_unref(baseInput), {
                                  key: 0,
                                  modelValue: item.type_name,
                                  "onUpdate:modelValue": ($event: any) => ((item.type_name) = $event),
                                  value: item.type_name,
                                  required: "",
                                  onBlur: ($event: any) => (update(index, 'type_name'))
                                }, {
                                  label: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.type_name")) + " *", 1)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "onUpdate:modelValue", "value", "onBlur"]))
                              : _createCommentVNode("", true),
                            _createVNode(_unref(baseInput), {
                              modelValue: item.name,
                              "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                              value: item.name,
                              required: "",
                              onBlur: ($event: any) => (update(index, 'name'))
                            }, {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " *", 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onUpdate:modelValue", "value", "onBlur"]),
                            _createElementVNode("div", _hoisted_6, [
                              (item?.document_type === 'OTHER')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("div", _hoisted_7, [
                                      _createVNode(_unref(baseSelect), {
                                        modelValue: item.document_type,
                                        "onUpdate:modelValue": ($event: any) => ((item.document_type) = $event),
                                        value: item.document_type,
                                        options: documentOptions.value,
                                        required: "",
                                        onChange: ($event: any) => (changeDocumentType(index, $event))
                                      }, {
                                        label: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)("common.labels.document_type")) + " * ", 1)
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "onUpdate:modelValue", "value", "options", "onChange"]),
                                      _createVNode(_unref(baseInput), {
                                        modelValue: item.document_name,
                                        "onUpdate:modelValue": ($event: any) => ((item.document_name) = $event),
                                        value: item.document_name,
                                        placeholder: _unref(t)('common.placeholders.describe'),
                                        required: "",
                                        onBlur: ($event: any) => (update(index, 'document_name'))
                                      }, {
                                        label: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)("common.labels.document_name")) + " *", 1)
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "onUpdate:modelValue", "value", "placeholder", "onBlur"])
                                    ]),
                                    _createVNode(_unref(baseInput), {
                                      modelValue: item.document_number,
                                      "onUpdate:modelValue": ($event: any) => ((item.document_number) = $event),
                                      value: item.document_number,
                                      placeholder: _unref(t)('common.labels.number'),
                                      mask: (event) => documentMask(index, event),
                                      required: "",
                                      onBlur: ($event: any) => (update(index, 'document_number'))
                                    }, {
                                      label: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)("common.labels.number")) + " *", 1)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onUpdate:modelValue", "value", "placeholder", "mask", "onBlur"])
                                  ], 64))
                                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createVNode(_unref(baseSelect), {
                                      modelValue: item.document_type,
                                      "onUpdate:modelValue": ($event: any) => ((item.document_type) = $event),
                                      value: item.document_type,
                                      options: documentOptions.value,
                                      required: "",
                                      onChange: ($event: any) => (changeDocumentType(index, $event))
                                    }, {
                                      label: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)("common.labels.document_type")) + " * ", 1)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onUpdate:modelValue", "value", "options", "onChange"]),
                                    _createVNode(_unref(baseInput), {
                                      modelValue: item.document_number,
                                      "onUpdate:modelValue": ($event: any) => ((item.document_number) = $event),
                                      value: item.document_number,
                                      placeholder: _unref(t)('common.labels.number'),
                                      mask: (event) => documentMask(index, event),
                                      required: "",
                                      onBlur: ($event: any) => (update(index, 'document_number'))
                                    }, {
                                      label: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)("common.labels.number")) + " *", 1)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onUpdate:modelValue", "value", "placeholder", "mask", "onBlur"])
                                  ]))
                            ]),
                            _createVNode(_unref(baseTextarea), {
                              modelValue: item.description,
                              "onUpdate:modelValue": ($event: any) => ((item.description) = $event),
                              value: item.description,
                              placeholder: _unref(t)('common.placeholders.describe'),
                              onBlur: ($event: any) => (update(index, 'description'))
                            }, {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onUpdate:modelValue", "value", "placeholder", "onBlur"])
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_unref(baseSignature), {
                              signature: item.signature,
                              "show-actions": true,
                              "show-del": true,
                              width: "100%",
                              onSave: ($event: any) => (saveSignature(index, $event)),
                              onDel: ($event: any) => (del(item))
                            }, null, 8, ["signature", "onSave", "onDel"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "btn btn-md btn-primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (addSignature()))
                }, _toDisplayString(_unref(t)("common.labels.add", {
                concat: _unref(t)("common.labels.signature"),
              }).toUpperCase()), 1)
              ])
            ], 64))
      ])
    ], 2),
    _createVNode(_unref(baseConfirm), {
      show: showConfirmDel.value,
      "max-width": "400px",
      title: 
      _unref(t)('common.labels.remove', {
        concat: _unref(t)('common.labels.signature'),
      }).toUpperCase()
    ,
      message: 
      _unref(t)('common.texts.remove_message', { concat: _unref(t)('common.labels.signature') })
    ,
      onCancel: delCancel,
      onConfirm: delConfirm
    }, null, 8, ["show", "title", "message"])
  ], 64))
}
}

})